module.exports = __webpack_public_path__ + "img/at-sign.7fb4ba02.svg";